import { Heading, HeaderWrapper } from './styled-components';

type Props = React.PropsWithChildren<{
  heading: React.ReactNode;
  headingLevel: 1 | 2 | 3 | 4 | 5 | 6;
}>;

export const Header = ({ heading, headingLevel, children }: Props) => (
  <HeaderWrapper>
    <Heading $as={`h${headingLevel}`}>{heading}</Heading>
    {children}
  </HeaderWrapper>
);
